import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { id: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]

import Head from "@/components/head/Head.vue";
import { onMounted, ref } from "vue";

import shouye from "@/assets/images/shouye.png";
import shouyeCopy from "@/assets/images/shouye-copy.png";
import liebiao from "@/assets/images/liebiao.png";
import liebiaoCopy from "@/assets/images/liebiao-copy.png";
import wode from "@/assets/images/wode.png";
import wodeCopy from "@/assets/images/wode-copy.png";
import router from "@/router";
import { getCache, setCache } from "@/utils/cache";
import { Info, LastHref } from "@/constants/cacheKey";
import { getUserInfo } from "@/api/User";
import { ElMessage } from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const tabSelect = ref<number>(0);

const tabs = ref([
  {
    label: "首页",
    href: "/project/index",
    titleShow: true,
    icon: shouye,
    iconSelect: shouyeCopy,
  },
  {
    label: "提交事件列表",
    href: "/event-list/index",
    titleShow: true,
    icon: liebiao,
    iconSelect: liebiaoCopy,
  },
  {
    label: "我的",
    href: "/my/index",
    titleShow: false,
    icon: wode,
    iconSelect: wodeCopy,
  },
]);

const title = ref("");

// tab点击
function handleTabClick(item: any, index: number) {
  tabSelect.value = index;
  router.push(item.href);
  setCache(LastHref, { item: item, index: index });
  title.value = item.titleShow ? item.label : "";
  // document.title = item.label
}

function onInfo() {
  getUserInfo()
    .then((res) => {
      if (res.code === 200) {
        setCache(Info, res.data);
        return;
      }
      ElMessage.error({
        message: res.msg,
        offset: 64,
      });
    })
    .catch((err) => {
      ElMessage.error({
        message: err.message,
        offset: 64,
      });
    });
}

onMounted(() => {
  onInfo();

  const obj = getCache(LastHref);
  if (obj) {
    handleTabClick(obj.item, obj.index);
    return;
  }
  handleTabClick(tabs.value[0], 0);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Head, {
      "head-height": 44,
      title: title.value
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "tab",
          key: index,
          onClick: ($event: any) => (handleTabClick(item, index))
        }, [
          _createElementVNode("img", {
            class: "img",
            src: tabSelect.value === index ? item.iconSelect : item.icon
          }, null, 8, _hoisted_4),
          _createElementVNode("span", {
            class: _normalizeClass(tabSelect.value === index ? 'select' : 'no-select')
          }, _toDisplayString(item.label), 3)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ], 64))
}
}

})